module.exports = __webpack_public_path__ + "img/card.1f0d6a5a.svg";